import type { BoothBeat } from './booth.ts';

/** A retrospective cannot air until the last turn it describes has resolved. */
export function beatEndsAt(beat: Pick<BoothBeat, 'turn' | 'kind' | 'turnsCovered'>): number {
  return beat.turn + (beat.kind === 'quiet' ? Math.max(0, beat.turnsCovered - 1) : 0);
}
